module.exports = __webpack_public_path__ + "static/media/img-lang-en.48dc2a04.svg";